import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const cloudServiceField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud service',
    context:
      'An identifier for the cloud service used. Examples: AWS Lambda, Google Storage.',
  }),
  externalDescription: msg({
    message:
      'An identifier for the cloud service used. Examples: AWS Lambda, Google Storage.',
    context: 'Cloud service',
  }),
};

export const cloudVmInstanceTypeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud virtual machine instance type',
    context: 'The virtual machine instance type for the cloud usage.',
  }),
  externalDescription: msg({
    message: 'The virtual machine instance type for the cloud usage.',
    context: 'Cloud virtual machine instance type',
  }),
};
